import { PATHS } from "@/lib/router";
import { OrganizationPage } from "./pages";

export const organizationRoutes = [
  {
    path: PATHS.ORGANIZATION,
    element: <OrganizationPage />,
  },
];
